import { ViewBreakpoint } from '../models/view-breakpoint.enum';
import { ViewLayoutModel } from '../models/view-layout.model';
import { TreeSearchDisplayMode } from 'src/app/shared/components/tree/tree-search/tree-search.component';
import { LoaderTypeEnum } from '../models/loader-type.enum';

export namespace ViewActions {
  export class SetBreakpoint {
    static readonly type = '[View] Set Breakpoint';
    constructor(public breakpoint: ViewBreakpoint) { }
  }

  export class SetCanHover {
    static readonly type = '[View] Set Can Hover';
    constructor(public canHover: boolean) { }
  }

  export class SetCanTouch {
    static readonly type = '[View] Set Can Touch';
    constructor(public canTouch: boolean) { }
  }

  export class SetCanFullscreen {
    static readonly type = '[View] Set Can Fullscreen';
    constructor(public canFullscreen: boolean) { }
  }

  export class SetLayout {
    static readonly type = '[View] Set Layout';
    constructor(public layout: ViewLayoutModel) { }
  }

  export class SetInitialLayout {
    static readonly type = '[View] Set Initial Layout';
    constructor(public layout: ViewLayoutModel) { }
  }

  export class SetInputEnabled {
    static readonly type = '[View] Set Input Enabled';
    constructor(public enabled: boolean) { }
  }

  export class SetSearchDisplayMode {
    static readonly type = '[View] Set Search Display Mode';
    constructor(public mode: TreeSearchDisplayMode) { }
  }

  export class TogglePresentation {
    static readonly type = '[View] Toggle Presentation';
    constructor(public active: boolean) { }
  }

  export class ToggleHelp {
    static readonly type = '[View] Toggle Help';
    constructor(public show: boolean) { }
  }

  export class ToggleLoader {
    static readonly type = '[View] Toggle Loader';
    constructor(public show: boolean) { }
  }

  export class SetLoaderType {
    static readonly type = '[View] Set Loader Mode';
    constructor(public loaderType: LoaderTypeEnum) { }
  }

  export class ToggleNodeInfo {
    static readonly type = '[View] Toggle Node Info';
    constructor(public show: boolean) { }
  }

  export class SetMultiPickModeEnabled {
    static readonly type = '[View] Set multi pick mode enabled';
    constructor(public enabled: boolean) { }
  }

  export class SetLabelBreakpoint {
    static readonly type = '[View] Set label breakpoint';
    constructor(public labelsBreakpoint: number) { }
  }

  export class SetUsePrintImage {
    static readonly type = '[View] Set use print image';
    constructor(public usePrintImage: boolean) { }
  }

}
